<script>
import { Line } from 'vue-chartjs'
import moment from 'moment'
export default {
    extends: Line,
    data() {
        var dates = _.map(this.inspections, 'date');
        var pestsl = _(this.properties).values().map(_.keys).flatten().uniq().value();
        var labels = _.map(dates, function(d) { return moment(d).format('D.M.YYYY'); });
        var that = this;
        return {
            chartData: {
                labels: labels,
                datasets: _.map(pestsl, (c) => {
                    return {
                        label: that.pests[c].name,
                        data: _.map(dates, (k) => {
                            if(_.isUndefined(that.properties[k])) return null;
                            if(_.isUndefined(that.properties[k][c])) return null;
                            if(_.isEmpty(that.properties[k][c])) return null;
                            return _.sum(_.map(_.uniqBy(that.properties[k][c], 'id'), 'quantity'))
                        }),
                        fill: false,
                        borderWidth: 1
                    };
                })
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            stepSize: 1,
                            beginAtZero: true
                        },
                        gridLines: {
                            display: true
                        }
                    }],
                    xAxes: [{
                        gridLines: {
                            display: false
                        }
                    }]
                },
                legend: {
                    display: true,
                    position: 'right',
                    labels: {
                        font: {
                            size: 14,
                            fontColor: '#000'
                        }
                    }

                },
                spanGaps: true,
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    props: {
        inspections: Array,
        properties: Object,
        pests: Object
    },
    mounted() {
        this.renderChart(this.chartData, this.options)
    }
}
</script>